<template>
  <a-form
    id="components-form-demo-normal-login"
    style="width: 100%; margin: 0 auto; padding: 30px 0 0"
    :form="form"
    class="login-form"
    @submit="handleSubmit"
  >
    <a-form-item>
      <a-input
        v-decorator="[
          'username',
          {
            rules: [
              {
                required: true,
                message: `${$t('请输入手机号/邮箱')}`,
                whitespace: true,
              },
            ],
          },
        ]"
        size="large"
        :placeholder="$t('请输入手机号/邮箱/子账号')"
      >
        <template #prefix>
          <a-icon type="user" style="color: rgba(0, 0, 0, 0.25)" />
        </template>
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input-password
        v-decorator="[
          'password',
          {
            rules: [
              {
                required: true,
                message: `${$t('请输入密码（6-18位）')}`,
                whitespace: true,
              },
            ],
          },
        ]"
        size="large"
        type="password"
        :placeholder="$t('请输入密码（6-18位）')"
      >
        <template #prefix>
          <a-icon type="lock" style="color: rgba(0, 0, 0, 0.25)" />
        </template>
      </a-input-password>
    </a-form-item>
    <a-form-item>
      <div class="agreement-container">
        <a-checkbox
          v-decorator="[
            'agreement',
            {
              valuePropName: 'checked',
              initialValue: false,
              rules: [
                {
                  validator: (rule, value, callback) => {
                    if (!value) {
                      callback('请阅读并同意相关协议')
                    } else {
                      callback()
                    }
                  },
                },
              ],
            },
          ]"
          @change="onAgreementChange"
        >
          <span style="font-size: 12px !important"
            >{{ $t('勾选表示您同意并愿意遵守云展动力平台以下协议政策') }}：
            <router-link to="/agreement/service" target="_blank">{{ $t('云展动力平台服务协议') }}</router-link>
            <router-link to="/privacy" target="_blank">{{ $t('法律声明与隐私权政策') }}</router-link>
            <router-link to="/copyright-legal-disclaimer" target="_blank">{{ $t('版权政策与法律说明') }}</router-link>
          </span>
        </a-checkbox>
      </div>
    </a-form-item>

    <a-form-item>
      <a @click="switchTabs('findPwd')">{{ $t('找回密码') }}?</a>
      <a-button
        size="large"
        type="primary"
        html-type="submit"
        class="login-form-button"
        :loading="loading"
        :disabled="!agreementChecked"
        style="margin-bottom: 20px"
      >
        {{ $t('登录') }}
      </a-button>
    </a-form-item>

    <div style="font-size: 18px; text-align: center">
      <span>{{ $t('还没有账号') }}</span>
      <a @click="switchTabs('register')">{{ $t('立即注册') }}</a>
    </div>
    <a-divider>
      <span style="color: #717171">{{ $t('其他登录方式') }}</span>
    </a-divider>
    <v-img
      :src="ICON_WENXIN"
      alt="微信"
      width="60"
      style="
        width: 60px;
        left: 50%;
        position: relative;
        transform: translate(-50%, 0);
        cursor: pointer;
        margin-bottom: 20px;
      "
      @click="switchTabs('wechatLogin')"
    />
  </a-form>
</template>
<script>
import { timeFix } from '@/utils/util'
import { ICON_WENXIN } from '@/const/image'

export default {
  name: 'LoginPage',
  props: {
    // 弹窗登录或注册时传入reload 刷新当前页
    backPath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      ICON_WENXIN,
      agreementChecked: false, // 新增协议勾选状态
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'normal_login' })
  },
  methods: {
    onAgreementChange(e) {
      this.agreementChecked = e.target.checked
    },

    handleSubmit(e) {
      e.preventDefault()
      // 如果协议未勾选，阻止提交
      if (!this.agreementChecked) {
        this.$message.warning('请阅读并同意相关协议')
        return
      }

      this.form.validateFields((err, userInput) => {
        if (!err) {
          // 新的登录
          userInput.username = userInput.username.trim()
          userInput.grant_type = 'password'
          userInput.scope = 'server'
          console.log(userInput)
          // TODO 登录前loading
          this.loading = true

          // // 清空cookie
          // this.$cookies.removeAll();
          // // 清空local
          // localStorage.clear();

          // 查看现在的store
          console.log(this.$store.state, 'this.$store')

          this.$store
            .dispatch('loginByUsername', userInput)
            .then((msg) => {
              console.log('then', msg)
              if (msg) {
                this.loading = false
                if (msg === '密码错误') {
                  this.form.setFieldsValue({
                    password: '',
                  })
                }
              } else {
                userInput.isLogin = true
                this.$store
                  .dispatch('getUserInfo', userInput)
                  .then((res) => {
                    console.log('then2', res)
                    this.loading = false
                    if (res && res.code === 0) {
                      if (res.data.username) {
                        this.$notification.success({
                          message: `${this.$t('欢迎您')},${res.data.username}`,
                          description: `${this.$t(timeFix())},${this.$t('欢迎回来')}`,
                        })
                      }
                      this.$initWebIM({ status: 'normalLogin' })
                      this.$store.commit('switchPopupLoginStatus', false)
                    } else {
                      this.$notification.error({
                        message: this.$t('获取会员信息失败'),
                        description: '服务器错误,请稍候再试',
                      })
                    }
                  })
                  .catch((e) => {
                    // TODO 异常处理
                    this.loading = false
                    console.log(e)
                  })
              }
            })
            .catch((e) => {
              console.log('catch', e)
              // TODO 异常处理
              this.loading = false
              this.$serverError()
            })
        }
      })
    },
    switchTabs(e) {
      this.$emit('switchTabs', e)
    },
  },
}
</script>
<style>
#components-form-demo-normal-login.login-form {
  max-width: 450px;
  margin: auto;
}

#components-form-demo-normal-login .login-form-forgot {
  float: right;
}

#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
</style>
